var map = {
	"./GDefaultTemplate.vue": [
		"0bb4",
		"chunk-a2ff838e"
	],
	"./GDefaultTemplateMenu.vue": [
		"7ff4",
		"chunk-4e4ffc6c"
	],
	"./GFullWidthTemplate.vue": [
		"7cdf0",
		"chunk-52c23ffb"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "3ed7";
module.exports = webpackAsyncContext;